<div [ngClass]="{ 'black-panel': openFilter, panel: !openFilter }">
  <mat-expansion-panel class="filter-position" [attr.expanded]="openFilter" (opened)="openEvent()" (closed)="closeEvent()">
    <mat-expansion-panel-header class="filt-custom">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-9">
            <mat-chip-listbox>
              <mat-chip *ngFor="let f of filtersMap">{{ f.filter }}</mat-chip>
            </mat-chip-listbox>
          </div>
          <div class="col-md-2">
            <mat-panel-title class="filter-title"> Filters </mat-panel-title>
          </div>
        </div>
      </div>
    </mat-expansion-panel-header>

    <div class="container-fluid">
      <div class="row pt-3">
        <div class="filter-box col-md-12 text-light-secondary margin-top-5">
          <div class="row justify-content-center row-cols-4">
            <div class="col">
              <mat-form-field>
                <textarea
                  cdkTextareaAutosize
                  #autosize="cdkTextareaAutosize"
                  cdkAutosizeMinRows="1"
                  cdkAutosizeMaxRows="5"
                  class="width-100"
                  matInput
                  [(ngModel)]="filters.sku"
                  placeholder="SKU"
                ></textarea>
              </mat-form-field>
            </div>

            <div class="col">
              <mat-form-field>
                <mat-select [(ngModel)]="filters.isConsistent" placeholder="Consistent" filterKey="name">
                  <mat-option [value]="null">None</mat-option>
                  <mat-option [value]="true">True</mat-option>
                  <mat-option [value]="false">False</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col">
              <app-brandon-autocomplete
                label="Suppliers"
                [allData]="suppliers"
                [(value)]="filters.supplierCode"
                filterKey="description"
                displayKey="description"
                valueKey="code"
                [isMulti]="false"
              ></app-brandon-autocomplete>
            </div>

            <div class="col">
              <app-brandon-autocomplete
                label="Stock Location"
                [allData]="stockLocation"
                [(value)]="filters.stockLocationCode"
                filterKey="code"
                displayKey="code"
                valueKey="code"
                [isMulti]="false"
              ></app-brandon-autocomplete>
            </div>

            <div class="col">
              <mat-form-field>
                <input matInput [(ngModel)]="filters.brand" placeholder="Brand" />
              </mat-form-field>
            </div>

            <div class="col">
              <mat-form-field>
                <input matInput [(ngModel)]="filters.category" placeholder="Category" />
              </mat-form-field>
            </div>

            <div class="col d-flex align-items-center">
              <mat-slide-toggle color="primary" [(ngModel)]="filters.hasQuantity">Quantity &gt; 0</mat-slide-toggle>
            </div>
          </div>
        </div>

        <div class="col-md-12 border-top-white text-center">
          <button type="submit" (click)="onSubmitFilter()">Filter</button>
          <button type="button" (click)="resetFilters()">Reset</button>
        </div>
      </div>
    </div>
  </mat-expansion-panel>
</div>
